import TooLongText from '@components/ui/TooLongText'

import { CopyAndPasteButton } from './CopyAndPaste'

interface InvoiceNumberProps extends Record<string, unknown> {
  badges: InvoiceBadgeValue[]
  invoiceNumber: Nullable<string>
  origin: InvoiceOrigin
}

export function InvoiceNumber({ invoiceNumber }: InvoiceNumberProps) {
  if (invoiceNumber == null) {
    return <span>-</span>
  }

  return (
    <CopyAndPasteButton text={invoiceNumber} noWrap>
      <TooLongText value={invoiceNumber} withPortal />
    </CopyAndPasteButton>
  )
}
